import React, { PureComponent, createRef } from "react";
import Modal from "react-responsive-modal";
import './ImportAtlasModal.scss';
import { Observer, GLOBAL_EVENT } from "../../../Observer";
import ImportAtlasRender from "./atlasRender/ImportAtlasRender";
import getFilesText from "../../../../../utils/getFilesText";
import isPhaserAtlas from "../../../../../utils/isPhaserAtlas";

// Componentes
interface stateInterface {
    open: boolean,
    width: number,
    height: number,
    separation: number,
    zoom: number
}

class ImportAtlas extends PureComponent<{}, stateInterface> {
    canva_atlas_container: React.RefObject<HTMLDivElement> = createRef<HTMLDivElement>();
    zoom_step = 10;

    constructor(props: any) {
        super(props);
        this.state = {
            open: false,
            width: 10,
            height: 10,
            separation: 0,
            zoom: 100
        }
        this.handleWheel = this.handleWheel.bind(this);
    }

    componentDidMount() {
        Observer.on(GLOBAL_EVENT.IMPORT_ATLAS.OPEN_ATLAS_IMPORT, (image) => {
            this.setState({
                ...this.state,
                open: true
            });
            setTimeout(() => {
                Observer.emit(GLOBAL_EVENT.IMPORT_ATLAS.OPEN_ATLAS_IMPORT_SEND_IMAGE, image);
            }, 20);
        });

        Observer.on(GLOBAL_EVENT.IMPORT_ATLAS.CLOSE_ATLAS_IMPORT, () => { this.handleCloseModal() });

    }

    handleCloseModal = () => {
        this.setState({
            ...this.state,
            open: false
        });
    }

    handleWheel(event: any) {
        if (event.ctrlKey) {
            const zoom = this.state.zoom;
            let value = zoom;
            if (Math.abs(event.deltaY) >= 0) {
                if (zoom > 20 && zoom <= 500) {
                    value = Number((zoom - this.zoom_step * event.deltaY / 100).toPrecision(2));
                    value = value < 20 ? value = 2 : value > 500 ? value = 500 : value;
                }
            }
            this.sendState({
                ...this.state,
                zoom: value
            });

            event.preventDefault();
            event.stopPropagation();
        }
    }

    sendState(options: any) {
        this.setState(options);
        Observer.emit(GLOBAL_EVENT.IMPORT_ATLAS.CHANGE_IMPORT_ATLAS_STATE, options);
    }

    handleInputZoom = (parcentInput: number) => {
        const minZoom = 20;
        const maxZoom = 500;
        const numberPercent: number = Math.round(parcentInput);
        const finalZoom: number = (numberPercent <= minZoom)
            ? minZoom
            : (numberPercent >= maxZoom)
                ? maxZoom
                : numberPercent;

        this.sendState({
            ...this.state,
            zoom: finalZoom
        });
    }

    componentDidUpdate() {
        if (!!this.state.open) {
            this.canva_atlas_container.current?.addEventListener('wheel', this.handleWheel, { passive: false });
        }
    }

    async handleImportAltas(event: React.ChangeEvent<HTMLInputElement>) {
        const files = event.target.files;
        const files_loaded = await getFilesText(files);

        if (isPhaserAtlas(files_loaded as string)) {
            Observer.emit(GLOBAL_EVENT.IMPORT_ATLAS.IMPORT_ATLAS_JSON, files_loaded);
            Observer.emit(GLOBAL_EVENT.NOTIFICATION_SYSTEM.CLEAR);
        } else {
            Observer.emit(GLOBAL_EVENT.NOTIFICATION_SYSTEM.ERROR, 'Atlas format incorrect');
        }
    }

    render() {
        return (
            <Modal open={this.state.open} onClose={this.handleCloseModal} closeOnOverlayClick={false} center classNames={{ outline: '10px solid red' }} styles={{ marginTop: '1000px' }}>
                <h3 className="noselect">Import Atlas Options</h3>

                <div className="noselect import-atlas-container" ref={this.canva_atlas_container}>
                    <div className="import-atlas-container--left">
                        <div className="canvas-atlas-container">
                            <ImportAtlasRender />
                        </div>
                        <div className="canvas-atlas-zoom">
                            <input type="number" id="atlas-container-input--zoom" value={this.state.zoom} onChange={(event) => {
                                this.handleInputZoom(Number(event.target.value));
                            }} /> %
                            <span id="atlas-zoom-minus" onClick={() => { this.handleInputZoom(this.state.zoom - 10); }}>-</span>
                            <span id="atlas-zoom-plus" onClick={() => { this.handleInputZoom(this.state.zoom + 10); }}>+</span>
                            <span id="atlas-zoom-reset" onClick={() => { this.handleInputZoom(100); }}>Reset</span>
                        </div>
                    </div>
                    <div className="import-atlas-container--right">
                        <div className="import-atlas--panel--container">
                            <div className="import-atlas-panel">
                                <label htmlFor="atlas_width">Width (px): </label>
                                <input type="number" id="atlas_width" min='1' value={this.state.width} onChange={(event) => {
                                    this.sendState({ 
                                        ...this.state, 
                                        width: Number(event.target.value) > 3 ? Number(event.target.value) : 4
                                    });
                                }} />
                            </div>
                            <div className="import-atlas-panel">
                                <label htmlFor="atlas_height">Height (px): </label>
                                <input type="number" id="atlas_height" min='1' value={this.state.height} onChange={(event) => {
                                       this.sendState({
                                        ...this.state,
                                        height: Number(event.target.value) > 3 ? Number(event.target.value) : 4
                                    });
                                }} />
                            </div>
                            <div className="import-atlas-panel">
                                <label htmlFor="atlas_separation">Space (px): </label>
                                <input type="number" id="atlas_separation" value={this.state.separation} onChange={(event) => {
                                    this.sendState({
                                        ...this.state,
                                        separation: Number(event.target.value)
                                    });
                                }} />
                            </div>
                        </div>
                        <div className="import-atlas-panel--buttons">
                            <button className="fileUpload">
                                Import atlas
                                <input type="file" className="upload cursor-pointer uploadSprites" accept="application/json" onChange={this.handleImportAltas} />
                            </button>
                            <button onClick={() => {
                                Observer.emit(GLOBAL_EVENT.IMPORT_ATLAS.IMPORT_ATLAS_GRID_BUTTON);
                            }
                            }>Import</button>
                        </div>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ImportAtlas;
